import React from "react";

import { Card, Row, Col } from "antd";
import './CardOrganisationProfile.scss';

export default function CardOrganisationProfile({ cardHeading, keyValueArray, otherKeyValue }) {
    return (
        <Card
            style={{
                marginTop: "15px",
                width: '100%',
                borderRadius: '10px',
                boxShadow: '0 10px 20px 0 rgba(113, 113, 113, 0.06)',
                border: 'solid 1px #F8F8F6',
                backgroundColor: '#fff'
            }}
        >
            <div className="card-heading">{cardHeading}</div>
            <Row>
                {keyValueArray && keyValueArray().map((obj, index) => {
                    return (
                        <Col key={index} className='gutter-row' span={8}>
                            <div className="card-key">{obj.key}</div>
                            <div className="card-value">{obj.value}</div>
                        </Col>
                    );
                })}

                {otherKeyValue && (
                    <Col className='gutter-row' span={24}>
                        <div className="card-key">{otherKeyValue.key}</div>
                        <div className="card-value">{otherKeyValue.value}</div>
                    </Col>
                )}

            </Row>
        </Card >
    );
}